import { render, staticRenderFns } from "./AppInputMoney.vue?vue&type=template&id=567ceae9"
import script from "./AppInputMoney.vue?vue&type=script&lang=ts"
export * from "./AppInputMoney.vue?vue&type=script&lang=ts"
import style0 from "./AppInputMoney.vue?vue&type=style&index=0&id=567ceae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports